export default "__VITE_ASSET__xvz9BB2e__"